var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.127 17.856a1.15 1.15 0 0 1 0 2.288l-.118.006H4a1.15 1.15 0 0 1 0-2.3h.009zM20 18a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2zM4.127 10.856a1.15 1.15 0 0 1 0 2.289l-.118.005H4a1.15 1.15 0 0 1 0-2.3h.009zM20 11a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2zM4.127 3.855a1.15 1.15 0 0 1 0 2.29l-.118.005H4a1.15 1.15 0 0 1 0-2.3h.009zM20 4a1 1 0 1 1 0 2H8a1 1 0 0 1 0-2z"
  })));
};
export default Svg24;